import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Slice = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 80;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FilterButtonWrapper = styled.div`
  position: relative;
`;

export const Label = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._500};
  white-space: nowrap;
`;

export const FilterHeader = styled.div`
  border-radius: 4px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border: 1px solid white;

  span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${Palette.PrimaryGray._700};
    white-space: nowrap;
  }
  svg {
    margin: 0 5px;
  }
  &:hover {
    background: ${() => Palette.PrimaryGray._100};
  }
  &:active {
    background: ${() => Palette.Primary._000};
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      border: 1px solid ${() => Palette.Primary._300};
      background: ${() => Palette.Primary._000};
      span {
        color: ${Palette.Primary._500};
      }
    `}
  transition: all 0.2s linear;
`;

export const Menu = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 100;
  width: max-content;
  height: auto;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  border-radius: 4px;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  margin: 0;
`;

export const ListWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;

export const DropDownList = styled('ul')`
  padding: 1px;
`;

export const ListItem = styled('li')`
  list-style: none;
  background: #ffffff;
  color: ${Palette.PrimaryGray._700};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid #ffffff;
  span {
    margin-left: 5px;
    padding: 10px 8px;
  }
  :hover {
    background: ${() => Palette.PrimaryGray._100};
    border: 1px solid ${() => Palette.PrimaryGray._100};
  }
  :active {
    color: ${() => Palette.Primary._500};
    background: ${() => Palette.PrimaryGray._100};
    border: 1px solid ${() => Palette.Primary._300};
  }
  transition: all 0.2s linear;
`;
